<template>
  <div v-if="isShow()" class="bar-layout" :style="{ 'padding-left': '32px', 'padding-right': '32px', 'margin-bottom': bottomMargin ? '8px' : '0' }">
    <div>{{ $t("explan.E" + getBaselineCode() + ".topic") }}</div>

    <!-- <van-button plain type="primary" size="small" @click="onClick">
			<div class="learn-button">
				<img fit="fill" src="@/assets/icon/book.png" style="width: 18px; height: 18px" />
				<span>
					{{ 'Learn' }}
				</span>
			</div>
		</van-button> -->

    <div @click="onClick()" class="bottom-btn" style="cursor: pointer">
      <div class="foot-btn-layout">
        <img style="width: 18px; height: 18px" src="@/assets/icon/book.png" fit="cover" alt="logo" />
        <div class="foot-btn-title">
          {{ $t("explan.common.learn") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "SEBar",
  props: {
    params: {
      type: Object,
      default: () => null
    },
    code: {
      type: [String, Number],
      default: 1000
    },
    bottomMargin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters("projectPre", ["objective"])
  },
  mounted() {},
  methods: {
    isShow() {
      // 显示条件
      if (this.objective == null) {
        return false
      }

      // 如果目标是 3 或 4，则暂时不显示
      if ([3, 4].includes(this.objective)) {
        return true // false
      }

      return true
    },
    onClick() {
      let actualCode = this.getBaselineCode()

      if ([3, 4].includes(this.objective)) {
        if (parseInt(actualCode) == 1000) {
          actualCode = parseInt(actualCode) + 1000
        }
      }
      console.log(`SECell clicked, code : ${actualCode}`)
      this.$selfExplanation({ code: actualCode })
    },
    // pre baseline code selected
    getBaselineCode() {
      if (!this.params) {
        return this.code
      }
      if (this.params.type === "baseline") {
        let stepKey = this.params.stepKey
        if (this.params.pathID == 1) {
          // path A
          if (stepKey == "StepMonthlyCoolingLoad") {
            return 10615
          } else if (stepKey == "ChillerPower") {
            return 10617
          }
        } else if (this.params.pathID == 2) {
          // path B
          if (stepKey == "EnergyConsumption") {
            return 10624
          } else if (stepKey == "ChillerPower") {
            return 10625
          } else if (stepKey == "StepMonthlyCoolingLoad") {
            return 10627
          }
        }
      }
      return this.code
    }
  }
}
</script>

<style scoped>
.bar-layout {
  width: 100%;
  height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  /* 底部阴影 */
  box-sizing: border-box;
  padding: 12px 16px;

  /* padding: 4px; */
  border-radius: 14px;

  border: var(--gray-line);
  box-shadow: var(--card-shadow);
  background: var(--white);
  transition: all 0.3s ease-in-out;
}

.learn-button {
  display: flex;
  align-items: center;
  gap: 4px;
}

.bottom-btn {
  border: 2px solid #1891f6;
  color: #003366;
  background: linear-gradient(to bottom, #ffffff, #e6e6e6);
  border-radius: 12px;
  padding: 6px 12px;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.08);
  transform: translateY(0);
}

.foot-btn-layout {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.foot-btn-title {
  color: #1891f6;
  padding-left: 8px;
  flex-grow: 1;
  white-space: normal‌;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/SelfExplanation/SEBar.vue